import { useEffect, useState } from 'react'

import { Col, Form, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap'
import { toast } from 'react-toastify'

import {
  ArrowClockwise,
  EyeFill,
  EyeSlashFill,
  PencilFill,
  PlusCircleFill,
  PrinterFill,
  Search,
  TrashFill,
} from 'react-bootstrap-icons'

import { CustomButton } from '../../../components/CustomButton'
import { CustomSpinner } from '../../../components/CustomSpinner'
import { IconButton } from '../../../components/IconButton'
import Navbar from '../../../components/navbar/navbar'

import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

import { Ask } from '../../../components/Ask'
import { useOrdenation } from '../../../hooks/useOrdenation'
import WmsAddressService from '../../../services/database/WmsAddressService'
import { getValue } from '../../../utils/getValue'
import { ModalCreatedAddressInfo } from './ModalCreatedAddressInfo'
import {
  default as ModalCriarEndereco,
  default as ModalEditarEndereco,
} from './ModalEndereco'
import { ModalImprimirMassa } from './ModalImprimirMassa'
import { ModalPrintLabel } from './ModalPrintLabel'

export function WMSEnderecos() {
  const [addresses, setAddresses] = useState([])
  const [isAddressesLoading, setIsAddressesLoading] = useState(true)
  const [isModalPrintIntervalLabelsOpen, setIsModalPrintIntervalLabelsOpen] =
    useState(false)
  const [isCreateAddressLoading, setIsCreateAddressLoading] = useState(false)
  const [isUpdateAddressLoading, setIsUpdateAddressLoading] = useState(false)
  const [isDeleteAddressLoading, setIsDeleteAddressLoading] = useState({})
  const [searchAddress, setSearchAddress] = useState({
    codendereco: '',
    deposito: '',
    rua: '',
    predio: '',
    nivel: '',
    apto: '',
    tipoender: '',
  })
  const [selectedCodendereco, setSelectedCodendereco] = useState(null)
  const [isSearchAddressLoading, setIsSearchAddressLoading] = useState(false)
  const [isModalCreateEnderecoOpen, setIsModalCreateEnderecoOpen] =
    useState(false)
  const [isModalUpdateEnderecoOpen, setIsModalUpdateEnderecoOpen] =
    useState(false)
  const [alreadyCreatedAddresses, setAlreadyCreatedAddresses] = useState([])
  const [isModalCreatedAddressInfo, setIsModalCreatedAddressInfo] =
    useState(false)
  const [isGetProductsOnAddressLoading, setIsGetProductsOnAddressLoading] =
    useState({})
  const [productsOnAddress, setProductsOnAddress] = useState({})
  const [isModalPrintLabelOpen, setIsModalPrintLabelOpen] = useState(false)
  const [selectedCodEndereco, setSelectedCodEndereco] = useState('')

  const {
    filteredItems: filteredAddresses,
    Th,
    Paginate,
    setItemsPerPage,
  } = useOrdenation(addresses, 'codendereco')

  function handleChangeAddress(e) {
    const { name, value } = e.target

    setSearchAddress((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function handleGetProducts(codendereco, index) {
    try {
      setIsGetProductsOnAddressLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const data = await WmsAddressService.getProductsOnAddress(codendereco)

      if (data?.addresses?.length === 0) {
        setProductsOnAddress({})
        return toast.info('Não há produtos nesse endereço')
      }

      setProductsOnAddress({
        [index]: data?.addresses,
      })
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível buscar os produtos do endereço',
      )
    } finally {
      setIsGetProductsOnAddressLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function handleSearchAddress() {
    try {
      setIsSearchAddressLoading(true)

      const addressesData = await WmsAddressService.getBySearch({
        codendereco: searchAddress.codendereco,
        rua: searchAddress.rua,
        deposito: searchAddress.deposito,
        apto: searchAddress.apto,
        nivel: searchAddress.nivel,
        predio: searchAddress.predio,
        tipoender: searchAddress.tipoender,
      })

      setProductsOnAddress({})
      setAddresses(addressesData)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar o endereço!')
    } finally {
      setIsSearchAddressLoading(false)
    }
  }

  function handleEnterPress(e) {
    if (e.ctrlKey && e.key === 'Enter') {
      return
    } else if (e.key === 'Enter') {
      handleSearchAddress()
    }
  }

  async function handleSelectAddress(codendereco) {
    setSelectedCodEndereco(codendereco)
    setIsModalPrintLabelOpen(true)
  }

  async function handleCreateAddress(data) {
    try {
      setIsCreateAddressLoading(true)

      const alreadyCreatedAddressesData = await WmsAddressService.create(data)

      loadAddresses()

      if (
        alreadyCreatedAddressesData &&
        alreadyCreatedAddressesData.length > 0
      ) {
        setAlreadyCreatedAddresses(alreadyCreatedAddressesData)
        setIsModalCreatedAddressInfo(true)
      } else {
        toast.success(`Endereço(s) criado com sucesso!`)
      }
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível criar o endereço!')
    } finally {
      setIsCreateAddressLoading(false)
    }
  }

  async function handleUpdateAddress(data) {
    const { codendereco, ...address } = data

    try {
      setIsUpdateAddressLoading(true)

      await WmsAddressService.update(codendereco, address)

      loadAddresses()
      toast.success(`Endereço atualizado com sucesso!`)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível atualizar o endereço!')
    } finally {
      setIsUpdateAddressLoading(false)
    }
  }

  async function handleDeleteAddress(codendereco, index) {
    try {
      setIsDeleteAddressLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      await WmsAddressService.delete(codendereco)

      loadAddresses()
      toast.success('Endereço deletado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível deletar o endereço!')
    } finally {
      setIsDeleteAddressLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function loadAddresses() {
    try {
      setIsAddressesLoading(true)

      const data = await WmsAddressService.getAll()

      setAddresses(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar os endereços!')
    } finally {
      setIsAddressesLoading(false)
    }
  }

  useEffect(() => {
    loadAddresses()
  }, [])

  return (
    <>
      <Navbar />

      <div className="mt-page">
        <h1>Endereços</h1>

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: 10,
          }}
        >
          <section>
            <p>Endereços por página</p>
            <Form.Select
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value))
              }}
              style={{
                width: '200px',
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Select>
          </section>

          <CustomButton
            title="Cadastrar"
            color="#27ae60"
            onClick={() => setIsModalCreateEnderecoOpen(true)}
          >
            <PlusCircleFill />
          </CustomButton>

          <CustomButton
            title="Recarregar"
            color="#0070da"
            onClick={loadAddresses}
            isLoading={isAddressesLoading}
            isLoadingText="Recarregando..."
          >
            <ArrowClockwise />
          </CustomButton>

          <CustomButton
            title="Imprimir Em Massa"
            color="#3c59e7"
            onClick={() => setIsModalPrintIntervalLabelsOpen(true)}
          >
            <PrinterFill />
          </CustomButton>
        </div>

        <Row className="mt-3">
          <Col>
            <Form.Label>Cód. End.</Form.Label>
            <Form.Control
              name="codendereco"
              value={searchAddress.codendereco}
              onChange={handleChangeAddress}
              onKeyDown={handleEnterPress}
              placeholder=""
            />
          </Col>

          <Col>
            <Form.Label>Dep.</Form.Label>
            <Form.Control
              name="deposito"
              value={searchAddress.deposito}
              onChange={handleChangeAddress}
              onKeyDown={handleEnterPress}
            />
          </Col>

          <Col>
            <Form.Label>Rua</Form.Label>
            <Form.Control
              name="rua"
              value={searchAddress.rua}
              onChange={handleChangeAddress}
              onKeyDown={handleEnterPress}
            />
          </Col>

          <Col>
            <Form.Label>Préd.</Form.Label>
            <Form.Control
              name="predio"
              value={searchAddress.predio}
              onChange={handleChangeAddress}
              onKeyDown={handleEnterPress}
            />
          </Col>

          <Col>
            <Form.Label>Nvl</Form.Label>
            <Form.Control
              name="nivel"
              value={searchAddress.nivel}
              onChange={handleChangeAddress}
              onKeyDown={handleEnterPress}
            />
          </Col>

          <Col>
            <Form.Label>Apto</Form.Label>
            <Form.Control
              name="apto"
              value={searchAddress.apto}
              onChange={handleChangeAddress}
              onKeyDown={handleEnterPress}
            />
          </Col>

          <Col>
            <Form.Label>Tipo End.</Form.Label>
            <Form.Select
              name="tipoender"
              value={searchAddress.tipoender}
              onChange={handleChangeAddress}
            >
              <option value="">Selecione</option>
              <option value="AP">AP</option>
              <option value="AE">AE</option>
            </Form.Select>
          </Col>

          <Col
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
            }}
          >
            <CustomButton
              title="Buscar"
              onClick={handleSearchAddress}
              isLoading={isSearchAddressLoading}
              isLoadingText="Buscando..."
            >
              <Search />
            </CustomButton>
          </Col>
        </Row>

        {isAddressesLoading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 50,
            }}
          >
            <CustomSpinner />
          </div>
        ) : filteredAddresses.length === 0 ? (
          <div
            style={{
              flex: 1,
              minHeight: '100%',
              padding: 50,
              textAlign: 'center',
            }}
          >
            <p>Sem endereços cadastrados</p>
          </div>
        ) : (
          <>
            <p
              className="mt-3"
              style={{
                textAlign: 'right',
              }}
            >
              Mostrando <strong>{filteredAddresses.length}</strong> de{' '}
              <strong>{addresses.length}</strong> endereços
            </p>

            <Table
              striped
              bordered
              hover
              responsive
            >
              <thead>
                <tr>
                  <Th
                    label="Cód. End"
                    value="codendereco"
                  />

                  <Th
                    label="Dep."
                    value="deposito"
                  />

                  <Th
                    label="Rua"
                    value="rua"
                  />

                  <Th
                    label="Préd."
                    value="predio"
                  />

                  <Th
                    label="Nvl"
                    value="nivel"
                  />

                  <Th
                    label="Apto"
                    value="apto"
                  />

                  <th>Tipo End.</th>

                  <th>Situação</th>

                  <th>Ativo</th>

                  <th>Bloqueio</th>

                  <th>Status</th>

                  <th>Cód Fabric.</th>

                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredAddresses.map((address, index) => (
                  <>
                    <tr key={address.codendereco}>
                      <td>{address.codendereco}</td>
                      <td>{address.deposito}</td>
                      <td>{address.rua}</td>
                      <td>{address.predio}</td>
                      <td>{address.nivel}</td>
                      <td>{address.apto}</td>
                      <td>{address.tipoender}</td>
                      <td>{address.situacao}</td>
                      <td>{address.ativo}</td>
                      <td>{address.bloqueio}</td>
                      <td>{address.status}</td>
                      <td>{getValue(address.codfabricante)}</td>
                      <td
                        style={{
                          display: 'flex',
                          gap: 5,
                        }}
                      >
                        <OverlayTrigger
                          overlay={<Tooltip>Visualizar Produtos</Tooltip>}
                        >
                          <IconButton
                            color="#155dec"
                            onClick={() =>
                              productsOnAddress[index]
                                ? setProductsOnAddress({})
                                : handleGetProducts(address.codendereco, index)
                            }
                            isLoading={isGetProductsOnAddressLoading[index]}
                          >
                            {productsOnAddress[index] ? (
                              <EyeSlashFill />
                            ) : (
                              <EyeFill />
                            )}
                          </IconButton>
                        </OverlayTrigger>

                        <OverlayTrigger
                          overlay={<Tooltip>Imprimir Etiqueta</Tooltip>}
                        >
                          <IconButton
                            color="#3c59e7"
                            onClick={() =>
                              handleSelectAddress(address.codendereco)
                            }
                          >
                            <PrinterFill />
                          </IconButton>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                          <IconButton
                            color="#e67e22"
                            onClick={() => {
                              setSelectedCodendereco(address.codendereco)
                              setIsModalUpdateEnderecoOpen(true)
                            }}
                          >
                            <PencilFill />
                          </IconButton>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Excluir</Tooltip>}>
                          <IconButton
                            isLoading={isDeleteAddressLoading[index]}
                            color="#c0392b"
                            onClick={() => {
                              Ask('Tem certeza que deseja excluir?', () =>
                                handleDeleteAddress(address.codendereco, index),
                              )
                            }}
                          >
                            <TrashFill />
                          </IconButton>
                        </OverlayTrigger>
                      </td>
                    </tr>

                    {productsOnAddress[index]?.length > 0 && (
                      <tr>
                        <td colSpan={13}>
                          <Table>
                            <thead>
                              <tr>
                                <th>SKU</th>
                                <th>Descrição</th>
                                <th>Quantidade</th>
                              </tr>
                            </thead>

                            <tbody>
                              {productsOnAddress[index]?.map((product) => (
                                <tr key={product.sku}>
                                  <td>{product.sku}</td>
                                  <td>{product.descricao}</td>
                                  <td>{product.qt}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </>
        )}
      </div>

      {isModalCreateEnderecoOpen && (
        <ModalCriarEndereco
          title="Criar Endereço"
          isOpen={isModalCreateEnderecoOpen}
          loadAddresses={loadAddresses}
          onClose={() => setIsModalCreateEnderecoOpen(false)}
          onSubmit={handleCreateAddress}
          isRequestLoading={isCreateAddressLoading}
        />
      )}

      {isModalUpdateEnderecoOpen && (
        <ModalEditarEndereco
          title="Editar Endereço"
          isOpen={isModalUpdateEnderecoOpen}
          onClose={() => setIsModalUpdateEnderecoOpen(false)}
          onSubmit={handleUpdateAddress}
          loadAddresses={loadAddresses}
          isRequestLoading={isUpdateAddressLoading}
          codendereco={selectedCodendereco}
        />
      )}

      {/* Modal para Imprimir Etiquetas */}
      {isModalPrintIntervalLabelsOpen && (
        <ModalImprimirMassa
          isOpen={isModalPrintIntervalLabelsOpen}
          onClose={() => setIsModalPrintIntervalLabelsOpen(false)}
        />
      )}

      {/* Modal para Mostrar Informações dos Endereços Criados */}
      {isModalCreatedAddressInfo && (
        <ModalCreatedAddressInfo
          isOpen={isModalCreatedAddressInfo}
          onClose={() => setIsModalCreatedAddressInfo(false)}
          alreadyCreatedAddresses={alreadyCreatedAddresses}
        />
      )}

      {isModalPrintLabelOpen && (
        <ModalPrintLabel
          isOpen={isModalPrintLabelOpen}
          onClose={() => setIsModalPrintLabelOpen(false)}
          codendereco={selectedCodEndereco}
        />
      )}
    </>
  )
}
